/*eslint no-underscore-dangle: ["error",
  { "allow": ["_renderItem", "_renderMenu", "_renderItemData", "_lastRequest"] }]*/
const AccountCenterSearch = {
  init(context) {
    this.context = context
    $("#account-center-search-js").autocomplete({
      minLength: 1,
      source: (request, response) => this.searchAccountCenter(request.term, response),
      select: (e, item) => {
        if (item.item) {
          this.context.selectPerson(item.item.account_center_id)
        }
        return false
      }
    })
    $("#account-center-search-js").data("ui-autocomplete")._renderItem = this.renderItem
    return ($("#account-center-search-js").data("ui-autocomplete")._renderMenu = this.renderMenu)
  },

  renderItem(ul, item) {
    let li
    this.context = AccountCenterSearch.context
    if (item.value === "__CREATE_A_NEW_PERSON_NOMATCHES__") {
      $(
        `<li class='ui-menu-item autocomplete-result p-1 ta-c' aria-label='${item.searchTerm}'><a tabindex='0' role='button' id='new_person' href='javascript://' class='btn-solid interaction w-100%'> Create a new person \"${item.searchTerm}\"</a></li>`
      ).appendTo(ul)
      return AccountCenterSearch.decorateNewPerson(ul, item.searchTerm)
    } else if (item.value === "__CREATE_A_NEW_PERSON_MATCHES__") {
      $(
        `<li class='ui-menu-item autocomplete-result p-1 ta-c' aria-label='${item.searchTerm}'><a tabindex='0' id='new_person' href='javascript://' class='btn-solid interaction w-100%'> Create a new person \"${item.searchTerm}\"</a></li>`
      ).appendTo(ul)
      return AccountCenterSearch.decorateNewPerson(ul, item.searchTerm)
    } else if (this.context.disabledItemCondition && this.context.disabledItemCondition(item)) {
      li = $(`<li class='ui-state-disabled' data-account-center-id='${item.account_center_id}'/>`)
      const avatar = `<img src='${item.cropped_avatar_url}' class='circle w-5 h-5 mr-1'/>`
      li.append(
        `<button class='ui-item-result autocomplete-result__link ${status}'>${avatar}<div class='autocomplete-result__details-wrapper'><div class='autocomplete-result__name'>${item.first_name} ${item.last_name} <span class='badge badge--subtle badge--tiny'>Admin</span></div><div class='autocomplete-result__details'>Admins can manage all signups</div></div></button></li>`
      )
      return li.appendTo(ul)
    } else {
      li = $(`<li class='autocomplete-result' data-account-center-id='${item.account_center_id}'/>`)
      let name = item.first_name

      name += ` ${item.last_name}`
      if (item.name_suffix) {
        name += ` ${item.name_suffix}`
      }

      let elm = `${name}`
      let status = item.status
      if (status == "inactive") {
        elm += ` (Inactive)`
      }

      const phone_number = item.contact_data.phone_numbers[0]
      const phone = phone_number ? $("<span>").text(phone_number.number)[0].outerHTML : ""

      const email_address = item.contact_data.email_addresses[0]
      const email = email_address ? $("<span>").text(email_address.address)[0].outerHTML : ""

      const membership = item.membership ? $("<span>").text(item.membership)[0].outerHTML : ""

      const address = item.contact_data.addresses[0]
      const city_state = address ? `<span>${address.city}, ${address.state}</span>` : ""

      const avatar = `<img src='${item.cropped_avatar_url}' class='circle w-5 h-5 mr-1'/>`

      li.append(
        `<button class='ui-item-result autocomplete-result__link ${status}'>${avatar}<div class='autocomplete-result__details-wrapper'><div class='f-1'><div class='autocomplete-result__name autocomplete-results__primary-content'>${elm}</div><div class='autocomplete-result__details autocomplete-results__primary-content'>${phone}${email}</div></div><div class='autocomplete-result__details ta-r'><div class='autocomplete-results__secondary-content'>${membership}</div><div class='autocomplete-results__secondary-content'>${city_state}</div></div></div></button></li>`
      )

      li.find(".safe-icon-wrap").append("")
      return li.appendTo(ul)
    }
  },

  decorateNewPerson(ul, searchTerm) {
    const new_person = $(ul).find("#new_person")
    new_person.attr("data-person-modal-id", "new")
    new_person.attr("data-redirect-to", AccountCenterSearch.context.redirectTo)
    new_person.attr("data-person-first-name", AccountCenterSearch.firstName(searchTerm))
    return new_person.attr("data-person-last-name", AccountCenterSearch.lastName(searchTerm))
  },

  renderMenu(ul, items) {
    this.context = AccountCenterSearch.context
    const that = this
    $(ul).addClass("autocomplete-results")
    if (this.context.additionalMenuClass) {
      $(ul).addClass(this.context.additionalMenuClass)
    }
    $.each(items, (index, item) => that._renderItemData(ul, item))
    if (items.length === 1) {
      const cleanTerm = items[0].searchTerm.replace('"', "")
      return $(ul).prepend(`\
<li class="autocomplete__no-results-message" aria-label="${cleanTerm}">"${cleanTerm}" doesn't exist in any Planning Center products yet.</li>\
`)
    }
  },

  searchAccountCenter(searchTerm, response) {
    if (this._lastRequest != null) {
      this._lastRequest.abort()
    }
    return (this._lastRequest = $.ajax({
      url: "/accounts/people",
      data: {
        q: searchTerm
      },
      success: people => {
        let value
        if (people.constructor === String) {
          people = JSON.parse(people)
        }
        if (people.length === 0) {
          value = "__CREATE_A_NEW_PERSON_NOMATCHES__"
        } else {
          value = "__CREATE_A_NEW_PERSON_MATCHES__"
        }
        people.push({
          value,
          searchTerm
        })
        return response(people)
      }
    }))
  },

  firstName(name) {
    return name
      .split(" ")
      .slice(0, -1)
      .join(" ")
  },

  lastName(name) {
    return name.split(" ").pop()
  }
}

export default AccountCenterSearch
